module.exports = __webpack_public_path__ + "static/media/sf-test-15.1399004a.mp3";